import { Grid } from "@mui/material";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { useEffect, useState } from "react";
import { apiConstants, post } from "../../common/constants";

function QcDetails({ data }) {
    const [qcData, setQcData] = useState();
    const expiredUrl = data.qcDetails?.images?.find((elem) => elem.signedURLExpired === true)

    useEffect(() => {
        if (expiredUrl) {
            post(apiConstants.REFRESH_S3_URL, data.qcDetails?.images).then((res) => {
                setQcData(res.data?.responseObj)
            }).catch((err) => {
                console.log(err);
            })
        } else {
            setQcData(data?.qcDetails?.images)
        }
    }, [expiredUrl])

    const columns = [
        {
            field: 'signedLink',
            headerAlign: "center",
            hideSortIcons: true,
            headerName: 'Link',
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container rowSpacing={2}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', height: 50 }}>
                                <a href={row?.signedLink} color="primary" target="_blank" rel="noreferrer">View</a>
                            </Grid>
                        </Grid>
                    </>
                )
            },
        }
    ]

    return (
        <ProzoDataGrid
            columns={columns}
            autoHeight={true}
            rows={(qcData && qcData.map((row, index) => ({ ...row, id: index }))) || []}
            pagination={false}
            hideFooterPagination={true}
            rowHeight={120}
            getRowId={(row) => row.id}
        />
    )
}

export default QcDetails;